import { useOffersQuery } from '@queries/useOffersQuery'

type UseOffersTotal = () => { all: number; public: number } | null

// minimum valid size
const size = 5

export const useOffersTotal: UseOffersTotal = () => {
  const { offersQuery: allQuery } = useOffersQuery([{ size }])
  const { offersQuery: publicQuery } = useOffersQuery([{ size, status: ['PUBLIC'] }])

  if (!allQuery.isSuccess || !publicQuery.isSuccess) return null

  return {
    all: allQuery.data.page.elementsTotal,
    public: publicQuery.data.page.elementsTotal,
  }
}
